import React from 'react';

export default (props) => {
  return (
    <div>
      <h1 className="display-4">404 Page Not Found</h1>
      <p className="lead">Sorry, the page doesn't exist</p>
    </div>
  );
};
